import httpClient from '@/api/http-client';

const endpoint = 'api/exams';

const examsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  update: (exam) => httpClient.put(`${endpoint}/${exam.id}`, exam),

  orderExams: (payload) => httpClient.post(`${endpoint}/order-exams`, payload),

  getOrderEligibility: (userId) => httpClient.get(`${endpoint}/order-eligibility/${userId}`),
  
  orderExamsUniversal: (payload) => httpClient.post(`${endpoint}/order-exams-universal`, payload),
};

export default examsService;
